import React from 'react';
import { Link } from 'react-router-dom';

const UpcomingEventCard = ({ event, onAddToCalendar, showAddToCalendar = true }) => {
  const { title, date, time, city, venue, category, priceLabel, imageUrl } = event;
  const to = `/events/${event.slug || event.id || ''}`;
  const isFree = !priceLabel || priceLabel === 'Free';

  return (
    <div className="bg-white rounded-2xl border border-gray-100 shadow-sm hover:shadow-lg transition-shadow overflow-hidden flex flex-col">
      {/* Image */}
      <div className="relative h-[120px] overflow-hidden bg-gray-100 group">
        <img
          src={imageUrl}
          alt=""
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        {/* Category badge — bottom left of image */}
        {category && (
          <span className="absolute bottom-2 left-2 rounded bg-emerald-700/90 backdrop-blur-sm px-1.5 py-0.5 text-[9px] font-semibold text-white line-clamp-1 max-w-[60%] shadow">
            {category}
          </span>
        )}
        {/* Price badge — top right of image */}
        <span
          className={`absolute top-2 right-2 rounded px-1.5 py-0.5 text-[9px] font-bold shadow ${
            isFree ? 'bg-emerald-600 text-white' : 'bg-red-500 text-white'
          }`}
        >
          {priceLabel || 'Free'}
        </span>
      </div>

      {/* Body */}
      <div className="px-3 py-2.5 flex-1 flex flex-col">
        <h3 className="font-semibold text-gray-900 text-[12px] leading-snug line-clamp-2 mb-1.5">
          {title}
        </h3>

        <div className="flex items-center gap-1 text-[10px] text-gray-500 mb-0.5">
          <svg className="h-3 w-3 flex-shrink-0 text-gray-400" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M6.75 3v2.25M17.25 3v2.25M3 18.75V7.5a2.25 2.25 0 012.25-2.25h13.5A2.25 2.25 0 0121 7.5v11.25m-18 0A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75m-18 0v-7.5A2.25 2.25 0 015.25 9h13.5A2.25 2.25 0 0121 11.25v7.5" />
          </svg>
          <span>{date}{time ? ` | ${time}` : ''}</span>
        </div>

        <div className="flex items-center gap-1 text-[10px] text-gray-500 mb-2">
          <svg className="h-3 w-3 flex-shrink-0 text-gray-400" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
            <path strokeLinecap="round" strokeLinejoin="round" d="M15 10.5a3 3 0 11-6 0 3 3 0 016 0z" />
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 10.5c0 7.142-7.5 11.25-7.5 11.25S4.5 17.642 4.5 10.5a7.5 7.5 0 1115 0z" />
          </svg>
          <span className="line-clamp-1">{city}{venue ? ` | ${venue}` : ''}</span>
        </div>

        {/* Action buttons */}
        <div className="flex gap-1.5 mt-auto">
          <Link
            to={to}
            className="inline-flex items-center gap-0.5 rounded border border-emerald-600 px-2 py-1 text-[10px] font-semibold text-emerald-700 hover:bg-emerald-50 transition-colors"
          >
            View Details
            <svg className="h-2.5 w-2.5" fill="none" viewBox="0 0 24 24" strokeWidth={3} stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" d="M8.25 4.5l7.5 7.5-7.5 7.5" />
            </svg>
          </Link>
          {showAddToCalendar && (
            <button
              type="button"
              onClick={(e) => { e.preventDefault(); onAddToCalendar?.(event); }}
              className="inline-flex items-center rounded border border-gray-300 px-2 py-1 text-[10px] font-medium text-gray-500 hover:bg-gray-50 transition-colors"
            >
              Add to Calendar
            </button>
          )}
        </div>
      </div>
    </div>
  );
};

export default UpcomingEventCard;
